import { useEffect } from "react";
import { useUserStore } from "../stores/useUserStore";

const useReferral = () => {
  const referral = useUserStore((s) => s.referral);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref && referral?.toLowerCase() !== ref?.toLowerCase()) {
      localStorage.setItem("referral_invited", ref);
    }
  }, []);
};

export default useReferral;
